import { jsx as _jsx } from "react/jsx-runtime";
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
import { FlexContainer } from '../layout/FlexContainer';
import { HorizontalTabItem } from './HorizontalTabItem';
export const HorizontalTabs = ({ items, testId, activeTab, }) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return (_jsx(FlexContainer, { verticalAlign: 'center', gap: '1/2', ...testIdAttribute, children: items.map(({ key, ...item }) => {
            const isActive = key === activeTab;
            return _jsx(HorizontalTabItem, { isActive: isActive, ...item }, key);
        }) }));
};
